module.exports = __webpack_public_path__ + "static/img/annual-leave.b2aeb4d9.svg";